import React from 'react';
import PropTypes from 'prop-types';
import Modal from "react-bootstrap/Modal";
import LoaderSpinner from '../common/Loader';
import Trash from "../../assets/trashRed.svg";
import { Col, Row } from "react-bootstrap";
import { processReviewCsv } from '../../store/actions';
import { allowedCSVExtension } from '../../constant';

const ProcessReview = (props) => {
    let { show, handleCancel, showLoader, toast, setShowLoader } = props;
    const [selectedFileName, setSelectedFileName] = React.useState("");
    const [fileSelected, setFileSelected] = React.useState();

    const onTrashClick = () => {
        setSelectedFileName(null);
        setFileSelected(null);
    };

    const handleUploadCsvFile = async (e) => {
        e.preventDefault();
        if (fileSelected) {
            setShowLoader(true);
            let formDataPayload = new FormData();
            formDataPayload.append("csvFile", fileSelected);
            let res = await processReviewCsv(formDataPayload);
            if (res?.data?.Status === 200) {
                toast.success('File processed successfully');
                setSelectedFileName(null);
                setFileSelected(null);
                handleCancel();
                window.open(res?.data?.Entity, '_blank');
            } else {
                toast.error(res?.data?.Message?.AppStatusDescription || 'Something went wrong');
            }
            setShowLoader(false);
        } else {
            toast.error("Please select a file to upload.");
        }
    };

    const handleUploadClick = (event) => {
        const extension = event.target.files[0].name.split(".").slice(-1).pop();
        if (!allowedCSVExtension.includes(extension ? extension.toLowerCase() : "")) {
            toast.error('Please select CSV file only');
            return;
        }
        
        if (event.target.files[0]) {
            setFileSelected(event.target.files[0]);
            setSelectedFileName(event.target.files[0].name);
        }
    };

    return (
        <Modal show={show} centered backdrop="static" className="modalDeleteWrapper" size="lg" onHide={handleCancel}>
            <Modal.Header
                closeButton
                onHide={handleCancel}
            >
                <div className="modal-main-div mb-3">
                    <span className="modal-m-text">Upload Review CSV </span>{showLoader && <LoaderSpinner />}
                    <p className='mt-0 fontFix'>This will apply charges or refunds to corresponding seller wallets</p>
                </div>
            </Modal.Header>
            <Modal.Body className="multiUploadDialog pt-5 fontFix">
                <div className="row">
                    <div className='col-12'>
                        <div className="row flexCenter">
                            <div className="col-sm-12 col-lg-4 formLabel alignRightRes">Select File <span className='require-field'>*</span></div>
                            <div className='col-sm-12 col-lg-6'>
                                {selectedFileName ? (
                                    <div>
                                        {selectedFileName}
                                        <span className="trash-icon">
                                            <button
                                                onClick={onTrashClick}
                                                aria-label="Remove selected file"
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'inline-block',
                                                    lineHeight: 0
                                                }}
                                            >
                                                <img
                                                    className="trash-Img"
                                                    src={Trash}
                                                    alt=""
                                                    style={{ pointerEvents: 'none' }}
                                                />
                                            </button>
                                        </span>
                                    </div>
                                ) : (
                                    <>
                                        <button className="btn-input-csv">
                                            <label className="btn-chooseFile" htmlFor={`processReviewFile`}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-upload"
                                                    viewBox="0 0 16 16"
                                                    cursor="pointer"
                                                >
                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                </svg>{" "}
                                                &nbsp; Choose File{" "}
                                            </label>
                                        </button>
                                        <input
                                            type="file"
                                            name="file"
                                            accept=".csv"
                                            id={`processReviewFile`}
                                            onChange={(e) => {
                                                handleUploadClick(e);
                                            }}
                                            hidden
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Row className="modaL_footer mt-0 mt-5 mr-2">
                <Col className="csv_Buttons">
                    <button
                        className="btn cus-seconday-bg-btn uploadBtn"
                        disabled={showLoader || !selectedFileName}
                        onClick={handleUploadCsvFile}
                    >Apply Adjustments</button>

                    <button
                        className="btn cus-seconday-bg-btn marginLeft5 cancelBtn"
                        onClick={handleCancel}
                        disabled={showLoader}
                    >
                        Cancel
                    </button>
                </Col>
            </Row>
        </Modal>
    );
}

ProcessReview.propTypes = {
    show: PropTypes.bool.isRequired,
    handleCancel: PropTypes.func.isRequired,
    showLoader: PropTypes.bool.isRequired,
    setShowLoader: PropTypes.func.isRequired,
    toast: PropTypes.shape({
        success: PropTypes.func.isRequired,
        error: PropTypes.func.isRequired
    }).isRequired
};

export default ProcessReview;